/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
function toggleMoreLess() {
  const moreText = document.querySelector('.moretext');
  const moreLessButton = document.querySelector('.moreless-button');
  
  if (moreText.classList.contains('show')) {
    moreText.classList.remove('show');
    moreLessButton.textContent = 'View all';
  } else {
    moreText.classList.add('show');
    moreLessButton.textContent = 'View less';
  }
}

(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
